import {companiesService} from '@/services/CompaniesService'

export const actions = {

    /**
     * @param commit
     * @param params
     * @returns {Promise<null|any>}
     * @throws null
     */
    getCompany: async ({commit}, params) => {
        try {
            const response = await companiesService.getCompanies(params)

            commit('SET_COMPANY', response.data)

            return response.data
        } catch (error) {
            return null
        }
    }

}
